import { HttpErrorResponse } from '@angular/common/http';

import { CreateChatMessageReq } from '@fb/models';

import { AuthService } from './auth.service';
import { AuthSessionError, isUnauthorizedStatus, UNAUTHORIZED_STATUS } from './auth-session.error';

function buildStreamHeaders(): Record<string, string> {
  return {
    Accept: 'text/event-stream',
    'Content-Type': 'application/json',
  };
}

export async function postAuthenticatedChatMessageStream(
  url: string,
  req: CreateChatMessageReq,
  authService: AuthService,
  signal: AbortSignal,
  retried = false,
): Promise<ReadableStream<Uint8Array>> {
  const response = await fetch(url, {
    method: 'POST',
    headers: buildStreamHeaders(),
    body: JSON.stringify(req),
    signal,
    credentials: 'include',
  });

  if (response.ok) {
    if (!response.body) {
      throw new Error('Chat message stream returned an empty body');
    }

    return response.body;
  }

  const detail = await response.text().catch(() => '');

  if (!retried && response.status === UNAUTHORIZED_STATUS) {
    await authService.renewSession();

    return postAuthenticatedChatMessageStream(url, req, authService, signal, true);
  }

  if (isUnauthorizedStatus(response.status)) {
    throw new AuthSessionError('Session expired', response.status);
  }

  throw new HttpErrorResponse({
    status: response.status,
    statusText: response.statusText,
    url: response.url,
    error: detail || response.statusText,
  });
}
